import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptQueryString, transformRequest } from '../../../utils/API/requestMiddleware';
import { defautBaseQuery } from '../../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";

const selfEvalutionReviewServiceApi = createApi({
    reducerPath: 'selfEvalutionReviewServiceApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        getFileListBySelfEvalRequirementIdForAdmin: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/GetFileListBySelfEvalRequirementIdForAdmin',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAdditionalFieldValueBySelfEvalRequirementIdForAdmin: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetAdditionalFieldValueBySelfEvalRequirementIdForAdmin`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSelfEvaluationRequirementBySelfEvaluationIdForAdmin: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetSelfEvaluationRequirementBySelfEvaluationIdForAdmin?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        approveSelfEvaluationRequirementByCaseOfficer: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/ApproveSelfEvaluationRequirementByCaseOfficer',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        submitClarificationForSelfEvaluationRequirementByCaseOfficer: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/SubmitClarificationForSelfEvaluationRequirementByCaseOfficer',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        rejectSelfEvaluationRequirementByCaseOfficer: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/RejectSelfEvaluationRequirementByCaseOfficer',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        saveSelfEvalutionFormInfomationByCaseOfficer: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/SaveSelfEvalutionFormInfomationByCaseOfficer',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        rejectSelfEvalutionApplicationByCaseOfficer: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/RejectSelfEvalutionApplicationByCaseOfficer',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        sendClarificationForExistingRequirement: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/SendClarificationForExistingRequirement',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        processForCretificateGrouping: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/ProcessForCretificateGrouping',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        saveSelfEvalutionFormInfomationByPeerReviewer: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/SaveSelfEvalutionFormInfomationByPeerReviewer',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        returnApplicationToCaseOfficerByPeerReviewer: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/ReturnApplicationToCaseOfficerByPeerReviewer',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        sendApplicationToCertification: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/SendApplicationToCertification',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        savePeerReviewerEvaluationDetails: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/SavePeerReviewerEvaluationDetails',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getPeerReviewEvaluationDetailsById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetPeerReviewEvaluationDetailsById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCertificateGroupingDetailsForGWPConcreteById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetCertificateGroupingDetailsForGWPConcreteById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        uploadCostAllocation: builder.mutation({
            query: (formData) => ({
                url: "/CaseOfficerAndPeerReviewer/UploadCostAllocation",
                method: "POST",
                body: formData,
            }),

        }),
        saveCertificateAndCostAllocationListForGWPConcrete: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/SaveCertificateAndCostAllocationListForGWPConcrete',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteCertificateCostAllocExcelUploadByGroupingId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/DeleteCertificateCostAllocExcelUploadByGroupingId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        downloadCostAllocationDoc: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/DownloadCostAllocationDoc',
                method: 'POST',
                body: transformRequest(details),
                responseHandler: (response) => response.blob(),
            }),
            // transformResponse: transformSucessResponse,
            // transformErrorResponse: transformErrorResponse,
        }),
        getTVOCorFormaldehydeEmissionList: builder.query({
            query: () => ({
                url: encryptQueryString('/CaseOfficerAndPeerReviewer/GetTVOCorFormaldehydeEmissionList'),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getMinimumCriteriaForServiceByApplicationId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CRUD/GetMinimumCriteriaForServiceByApplicationId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getProductApplicationInformationId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetProductApplicationInformationId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCertificateProductsListByProductInformationId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetCertificateProductsListByProductInformationId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getServiceCompanyInformationDetailsById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetServiceCompanyInformationDetailsById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useGetFileListBySelfEvalRequirementIdForAdminMutation,
    useGetAdditionalFieldValueBySelfEvalRequirementIdForAdminMutation,
    useLazyGetSelfEvaluationRequirementBySelfEvaluationIdForAdminQuery,
    useApproveSelfEvaluationRequirementByCaseOfficerMutation,
    useSubmitClarificationForSelfEvaluationRequirementByCaseOfficerMutation,
    useRejectSelfEvaluationRequirementByCaseOfficerMutation,
    useSaveSelfEvalutionFormInfomationByCaseOfficerMutation,
    useRejectSelfEvalutionApplicationByCaseOfficerMutation,
    useSendClarificationForExistingRequirementMutation,
    useProcessForCretificateGroupingMutation,
    useSaveSelfEvalutionFormInfomationByPeerReviewerMutation,
    useReturnApplicationToCaseOfficerByPeerReviewerMutation,
    useSendApplicationToCertificationMutation,
    useSavePeerReviewerEvaluationDetailsMutation,
    useLazyGetPeerReviewEvaluationDetailsByIdQuery,
    useLazyGetCertificateGroupingDetailsForGWPConcreteByIdQuery,
    useUploadCostAllocationMutation,
    useSaveCertificateAndCostAllocationListForGWPConcreteMutation,
    useLazyDeleteCertificateCostAllocExcelUploadByGroupingIdQuery,
    useDownloadCostAllocationDocMutation,
    useLazyGetTVOCorFormaldehydeEmissionListQuery,
    useLazyGetMinimumCriteriaForServiceByApplicationIdQuery,
    useLazyGetProductApplicationInformationIdQuery,
    useLazyGetCertificateProductsListByProductInformationIdQuery,
    useLazyGetServiceCompanyInformationDetailsByIdQuery,
} = selfEvalutionReviewServiceApi;

export default selfEvalutionReviewServiceApi;